export function addTextInHTML(html, texto) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const paragraphs = doc.querySelector('p');

  if (paragraphs) {
    paragraphs.innerHTML = `${texto} ${paragraphs.innerHTML}`;
  }

  return doc.body.innerHTML;
}

/**
 * Limpia el texto de etiquetas HTML y entidades HTML
 * @param {string} html - Texto con HTML a limpiar
 * @returns {string} Texto limpio
 */
export function cleanHTML(html) {
  if (!html) return '';

  // Primero convertimos el HTML a texto plano
  const doc = new DOMParser().parseFromString(html, 'text/html');
  let text = doc.body.textContent || '';

  // Limpiamos espacios extras
  text = text.trim().replace(/\s+/g, ' ');

  return text;
}

/**
 * Convierte una cadena CSS con variables (formato :root) en un objeto JavaScript
 * Las claves del objeto resultante están en camelCase y se eliminan los prefijos '--'
 * Los valores de URL se limpian eliminando 'url(' y ')'
 *
 * @param {string} cssString - String CSS con variables en formato :root {...}
 * @returns {Object} Objeto con las variables CSS como propiedades
 *
 * @example
 * // Input: ":root{--color-primary:#ff0000;--bg-image:url('img.jpg');}"
 * // Output: {colorPrimary: "#ff0000", bgImage: "img.jpg"}
 */

export function parseCSSVarsToObject(cssString) {
  // Remove :root {} and split by semicolon
  const cleanString = cssString?.replace(/:root\s*{/, '')?.replace(/}$/, '');
  const varsArray = cleanString?.split(';').filter(Boolean);

  return (
    varsArray?.reduce((acc, variable) => {
      // Find the position of the first colon
      const colonIndex = variable?.indexOf(':');
      if (colonIndex === -1) return acc;

      // Split into key and value using the first colon only
      const key = variable?.substring(0, colonIndex)?.trim();
      const value = variable?.substring(colonIndex + 1)?.trim();

      if (key && value) {
        // Remove '--' from key and convert to camelCase
        const propertyName = key?.replace('--', '').replace(/-([a-z])/g, (g) => g[1].toUpperCase());

        // Validate URL values
        if (value.startsWith('url(')) {
          const urlValue = value.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
          try {
            new URL(urlValue);
            acc[propertyName] = urlValue;
          } catch {
            acc[propertyName] = undefined;
          }
        } else {
          acc[propertyName] = value;
        }
      }
      return acc;
    }, {}) || {}
  );
}
